import { http } from '@/plugins/http';

const API_CACHE = new Map();

export function resetCache() {
  API_CACHE.clear();
}

function API(route, params = {}, httpClient = null, { cache = true } = {}) {
  if (!httpClient) {
    httpClient = http;
  }

  const cacheKey = Object.keys(params || {})
    .sort()
    .reduce((acc, key) => (`${acc}/${key}/${params[key]}`), route)
    .replace(/\//g, '_');

  return {
    async fetch() {
      if (!cache) {
        API_CACHE.delete(cacheKey);
      }

      if (!API_CACHE.has(cacheKey)) {
        API_CACHE.set(cacheKey, httpClient.get(route, { params }));
      }

      return API_CACHE.get(cacheKey).then(({ data }) => data);
    },
  };
}

export default API;
